/**
 * Browser fingerprint for login — loaded on demand only (not on dictionary pages).
 */
export function getLoginFingerprint () {
  return new Promise((resolve, reject) => {
    async function getHash () {
      const [{ default: Fingerprint2 }, { default: UAParser }] = await Promise.all([
        import(/* webpackChunkName: "fingerprint" */ 'fingerprintjs2'),
        import(/* webpackChunkName: "fingerprint" */ 'ua-parser-js')
      ])

      const options = {
        excludes: {
          plugins: true,
          localStorage: true,
          adBlock: true,
          screenResolution: true,
          availableScreenResolution: true,
          enumerateDevices: true,
          pixelRatio: true,
          doNotTrack: true,
          preprocessor: (key, value) => {
            if (key === 'userAgent') {
              const parser = new UAParser(value)
              return `${parser.getOS().name} :: ${parser.getBrowser().name} :: ${parser.getEngine().name}`
            }
            return value
          }
        }
      }

      const components = await Fingerprint2.getPromise(options)
      const values = components.map(component => component.value)
      return String(Fingerprint2.x64hash128(values.join(''), 31))
    }

    const run = () => getHash().then(resolve).catch(reject)

    if (window.requestIdleCallback) {
      requestIdleCallback(run)
    } else {
      setTimeout(run, 500)
    }
  })
}
